import { Component, OnInit, ViewChild } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { BarsComponent } from './bars/bars.component';
import { ProductionComponent } from './production/production.component';
import { StorageComponent } from './storage/storage.component';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import {TimerObservable} from "rxjs/observable/TimerObservable";

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
  @ViewChild(HomeComponent) home: HomeComponent;
  @ViewChild(BarsComponent) bars: BarsComponent;
  @ViewChild(ProductionComponent) production: ProductionComponent;
  @ViewChild(StorageComponent) storage: StorageComponent;
  type = "";
  labels: any = {};
  data;
  showNodata = false;
  units: string[];
  private subscription: Subscription;
  private chartData: Array<any>;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {

  }
  unsetChart(){
    this.subscription.unsubscribe();
  }
  setChart(key: string, url: string, interval: number) {
    let timer = TimerObservable.create(0, 1000*interval);
    this.subscription = timer.subscribe(t => {
      this.http.get(url).subscribe(
        data => {
          this.data = data;
          this.updateChart(key);
        },
        error => {
          console.log("Data ERROR");
          this.showNodata = true;
          this.data = {
            "co2SavingsTotalWeek": 0,
            "co2SavingsTotalYear": 0,
            "fuelcount": {
                "today": {
                    "biogas": 0,
                    "hcng": 0,
                    "h2-350bar": 0,
                    "h2-700bar": 0
                },
                "7-days": {
                    "biogas": 0,
                    "hcng": 0,
                    "h2-350bar": 0,
                    "h2-700bar": 0
                },
                "last-year": {
                    "biogas": 0,
                    "hcng": 0,
                    "h2-350bar": 0,
                    "h2-700bar": 0
                }
            },
            "fuelmass": {
                "7-days": {
                    "biogas": 0,
                    "hcng": 0,
                    "h2-350bar": 0,
                    "h2-700bar": 0
                },
                "last-year": {
                    "biogas": 0,
                    "hcng": 0,
                    "h2-350bar": 0,
                    "h2-700bar": 0
                }
            },
            "pv": {
                "dayproduction": [],
                "current": 0,
                "7-days": 0,
                "last-year": 0
            },
            "h2": {
                "dayproduction": [],
                "current": 0,
                "7-days": 0,
                "last-year": 0
            },
            "h2storage": {
                "buffer": 0,
                "440bar": {
                    "low": 0,
                    "mid": 0,
                    "high": 0
                },
                "900bar": {
                    "low": 0,
                    "mid": 0,
                    "high": 0
                }
            }
        };
        this.updateChart(key);
        }
      );
    });
    this.type="";
    this.showNodata = false;
    
  }
  updateChart(key){
    if (key == "Home") {
      this.type = "Home";
      this.home.labels = this.labels;
      this.home.onUpdate(this.data.fuelcount, {
        "7-days": this.data.co2SavingsTotalWeek,
        "last-year": this.data.co2SavingsTotalYear
      }
      );
    }
    if (key == "PV") {
      this.type = "Production";
      this.production.labels = this.labels;
      this.units = [this.labels.kW, this.labels.kWh, this.labels.kWh];
      this.production.onUpdate(this.data.pv, this.units);
    }
    if (key == "H2") {
      this.type = "Production";
      this.production.labels = this.labels;
      this.units = [this.labels.kgh, this.labels.kg, this.labels.kg];
      this.production.onUpdate(this.data.h2, this.units);
    }
    if (key == "Storage") {
      this.type = "Storage";
      this.storage.labels = this.labels;
      this.storage.onUpdate(this.data.h2storage);
    }
    if (key == "Fuelcount") {
      this.type = "Bars";
      this.bars.labels = this.labels;
      this.bars.onUpdate(this.data.fuelcount);
    }
  }
  setLabels(labels: any) {
    this.labels = labels;
  }
}



// WEBPACK FOOTER //
// ./src/app/chart/chart.component.ts